import React from 'react';
import '../../../styles/global.css';

function ToyBox() {
  return (
    <div className="body-container">
      <h1>Toy Box</h1>
      <h4>Feb 2021</h4>
      <p>A looping animation of a cornell box with a mouse toy and other little knick-knacks!</p>
      <p>Modeling, Shading, and Animation done in Autodesk Maya.</p>
      <video src={require('./assets/cornell_box.mp4')} controls>
        <source src={require("./assets/cornell_box.mp4")} type="video/mp4" />
      </video>
    </div>
  );
};

export default ToyBox;
